/** Paths that should never be used as redirect targets after login. */
const BLACKLISTED_PATHS = ['/', '/login', '/register', '/sso-entry', '/backend-login']

/**
 * Validates a redirect path for post-login navigation.
 * Expects paths WITHOUT locale prefix (e.g. `/7/preorder/wishlist`, not `/en/7/preorder/wishlist`).
 * Blocks absolute URLs, protocol-relative URLs (`//evil.com`), and blacklisted auth pages.
 */
export function isValidRedirectPath(path: unknown): path is string {
  if (typeof path !== 'string' || path.length === 0) {
    return false
  }

  // Only allow relative paths — blocks absolute URLs and open-redirect via `//evil.com`
  if (!path.startsWith('/') || path.startsWith('//')) {
    return false
  }

  // Strip query params and hash before checking against blacklist
  const pathWithoutQuery = path.split('?')[0]!.split('#')[0]!
  return !BLACKLISTED_PATHS.some((blocked) => pathWithoutQuery === blocked)
}

/**
 * Strips the 2-letter locale prefix from a full path.
 * Example: `/en/7/preorder/wishlist` → `/7/preorder/wishlist`, `/en` → `/`
 */
export function stripLocalePrefix(fullPath: string): string {
  return fullPath.replace(/^\/[a-z]{2}(\/|$)/, '/')
}
